import React from 'react';

import { SVGComponentProps } from './svg.types';

const AIEnterSVG = ({
  fill = 'currentColor',
  size = '1em',
  ...otherProps
}: Omit<SVGComponentProps, 'wrapperClass'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M18.0703 8.51013L9.51026 4.23013C3.76026 1.35013 1.40026 3.71013 4.28026 9.46013L5.15026 11.2001C5.40026 11.7101 5.40026 12.3001 5.15026 12.8101L4.28026 14.5401C1.40026 20.2901 3.75026 22.6501 9.51026 19.7701L18.0703 15.4901C21.9103 13.5701 21.9103 10.4301 18.0703 8.51013ZM14.8403 12.7501H9.44026C9.03026 12.7501 8.69026 12.4101 8.69026 12.0001C8.69026 11.5901 9.03026 11.2501 9.44026 11.2501H14.8403C15.2503 11.2501 15.5903 11.5901 15.5903 12.0001C15.5903 12.4101 15.2503 12.7501 14.8403 12.7501Z"
        fill={fill}
      />
    </svg>
  );
};

export default AIEnterSVG;
